module.exports = __webpack_public_path__ + "static/media/file14.95b145bf.jpg";